import { routes } from '../router';

const getPathForRoute = (route) => routes.find(({ name }) => name === route)?.path;

export default getPathForRoute;
